/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Strength_FirstInputs */

const en_us2_wrapped_strength_first = /** @type {(inputs: Wrapped_Strength_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your first max strength estimate, the baseline for the weeks ahead.`)
};

const pt_br2_wrapped_strength_first = /** @type {(inputs: Wrapped_Strength_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua primeira estimativa de força máxima, a base das próximas semanas.`)
};

const es_419_wrapped_strength_first = /** @type {(inputs: Wrapped_Strength_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu primera estimación de fuerza máxima, la base de las próximas semanas.`)
};

const pt_pt2_wrapped_strength_first = /** @type {(inputs: Wrapped_Strength_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua primeira estimativa de força máxima, a base das próximas semanas.`)
};

const fr_fr2_wrapped_strength_first = /** @type {(inputs: Wrapped_Strength_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta première estimation de force max, la base des semaines à venir.`)
};

const de_de2_wrapped_strength_first = /** @type {(inputs: Wrapped_Strength_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine erste Schätzung der Maximalkraft, die Basis für die kommenden Wochen.`)
};

const it_it2_wrapped_strength_first = /** @type {(inputs: Wrapped_Strength_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua prima stima di forza massima, la base per le prossime settimane.`)
};

/**
* | output |
* | --- |
* | "Your first max strength estimate, the baseline for the weeks ahead." |
*
* @param {Wrapped_Strength_FirstInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_strength_first = /** @type {((inputs?: Wrapped_Strength_FirstInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Strength_FirstInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_strength_first(inputs)
	if (locale === "es-419") return es_419_wrapped_strength_first(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_strength_first(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_strength_first(inputs)
	if (locale === "de-DE") return de_de2_wrapped_strength_first(inputs)
	if (locale === "it-IT") return it_it2_wrapped_strength_first(inputs)
	return en_us2_wrapped_strength_first(inputs)
});
export { wrapped_strength_first as "wrapped.strength_first" }